import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';

import '../components/select-drawing';

import { styles } from '../styles/shared-styles';

@customElement('app-home')
export class AppHome extends LitElement {


  static styles = [
    styles,
    css`

  `];

  async firstUpdated() {
    // this method is a lifecycle even in lit
    // for more info check out the lit docs https://lit.dev/docs/components/lifecycle/
  }

  render() {
    return html`
      <main>
        <select-drawing></select-drawing>
      </main>
    `;
  }
}
